// components
import PoaSuccessPage from '@karehero/llama/components/pages/PoaSuccess/PoaSuccess';

/**
 * PoaSuccess renders the POA success screen.
 */
export const PoaSuccess = () => {
  return <PoaSuccessPage />;
};

PoaSuccess.displayName = 'PoaSuccess';
export default PoaSuccess;
